import React from 'react';

import PropTypes from 'prop-types';

import { Container, Inner } from './styles';

export const LightNavBar = (props) => {
    return (
        <Container>
            <Inner align={props.align} isSearchBar={props.isSearchBar}>
                {props.children}
            </Inner>
        </Container>
    );
};

LightNavBar.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.element),
        PropTypes.any, //TODO
    ]),
    align: PropTypes.oneOf(['left', 'right', 'space-between', 'center']),
    isSearchBar: PropTypes.bool,
};
